const GeneralConfig = {
  homepage: 'https://admin.louregelateria.id',
  apiHostname: 'https://api.louregelateria.id',
  hostname: 'https://admin.louregelateria.id',
  assetsHostname: 'https://api.louregelateria.id',
  /*homepage: 'http://localhost:3000',
  apiHostname: 'http://localhost:8000',
  hostname: 'http://localhost:3000',
  assetsHostname: 'http://localhost:8000',*/
  pusherApi: 'http://localhost:6001',
  dateFormat: 'DD/MM/YYYY',
  googleClientId: '',
  facebookAppId: '',
};

export default GeneralConfig;
